import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=3c5bf5ae&scoped=true&"
import script from "./customerService.vue?vue&type=script&lang=js&"
export * from "./customerService.vue?vue&type=script&lang=js&"
import style0 from "./customerService.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customerService.vue?vue&type=style&index=1&id=3c5bf5ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5bf5ae",
  null
  
)

export default component.exports